import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function AnnouncementsPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Announcements Management"
        subtitle="Manage marquee announcements and notices"
        contentType="announcements"
        fields={[
          // Basic Information
          { name: 'title', label: 'Announcement Title', type: 'text', required: true },
          { name: 'body', label: 'Announcement Details', type: 'richtext', hint: 'Optional detailed content with formatting' },
          { name: 'link_url', label: 'Announcement Link URL', type: 'text', placeholder: 'Link to more details (document or page)' },
          
          // Documents - File Upload
          { name: 'pdf_file', label: 'Attachment PDF', type: 'file', fileType: 'pdf', hint: 'Upload related document' },
          
          // Dates
          { name: 'last_date', label: 'Announcement Last Date', type: 'date', hint: 'NEW badge shows until this date' },
          
          // Display Settings
          { name: 'is_marquee', label: 'Show in Marquee', type: 'checkbox', defaultValue: true, checkboxLabel: 'Display in scrolling marquee banner' },
          { name: 'show_new', label: 'Show NEW Badge', type: 'checkbox', defaultValue: true, checkboxLabel: 'Display NEW badge (auto-hidden after last date)' },
          { name: 'priority', label: 'Priority', type: 'number', defaultValue: 10, min: 0, max: 100, hint: 'Lower number = higher priority in listings' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['title', 'last_date', 'is_marquee', 'priority', 'is_published']}
      />
    </AdminLayout>
  );
}
